import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { PASSWORD_HINT, passwordMatchValidator, strongPasswordValidator } from '../../../../shared/password.validators';

@Component({
  selector: 'app-aggiungi-utente-backoffice',
  templateUrl: './aggiungi-utente-backoffice.component.html',
  styleUrl: './aggiungi-utente-backoffice.component.css'
})
export class AggiungiUtenteBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  formUtente!: FormGroup;
  passwordHint = PASSWORD_HINT;

  tipi: { tipo: string }[] = [
    { tipo: 'Operatore' },
    { tipo: 'Amministratore' }
  ]

  ngOnInit(): void {
    this.formUtente = new FormGroup({
      username: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.email),
      password: new FormControl(null, [Validators.required, strongPasswordValidator('username')]),
      confirm_password: new FormControl(null, [Validators.required]),
      tipo: new FormControl(null, Validators.required)
    }, { validators: passwordMatchValidator() });
  }

  onSubmit() {
    let utente = {
      username: this.formUtente.get('username')?.value,
      email: this.formUtente.get('email')?.value || '',
      password: this.formUtente.get('password')?.value,
      tipo: this.formUtente.get('tipo')?.value.tipo
    }

    this.apiService.addUtente(utente).subscribe({
      next: () => this.apiService.setUtenti(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => { this.router.navigate(['/backoffice/utenti']) }
    })
  }
}
